import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/event-kiosks`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/event-kiosks/${id}`, options).then((response) => {
    let kiosk = jsona.deserialize(response.data);
    delete kiosk.links;
    return kiosk;
  });
}

function add(kiosk) {
  const payload = jsona.serialize({
    stuff: kiosk,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/event-kiosks`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(kiosk) {
  const payload = jsona.serialize({
    stuff: kiosk,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/event-kiosks/${kiosk.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/event-kiosks/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
